import { render, staticRenderFns } from "./ExpeditionA.vue?vue&type=template&id=06a46175&scoped=true&lang=html&"
import script from "./ExpeditionA.vue?vue&type=script&lang=js&"
export * from "./ExpeditionA.vue?vue&type=script&lang=js&"
import style0 from "./ExpeditionA.vue?vue&type=style&index=0&id=06a46175&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a46175",
  null
  
)

export default component.exports